const BUTTON_TYPES = {
  WATCH: 'PRIMARY_WATCH',
  NOTIFICATION: 'NOTIFICATION',
  TRAILER: 'TRAILER',
  RESTART: 'RESTART',
  WATCHLIST: 'WATCHLIST',
  PERSONALITY_FAVORITE: 'PERSONALITY_FAVORITE',
  MORE_DETAILS: 'MORE_DETAILS',
  UPSELL: 'UPSELL',
};

const SHOWCASE_TYPES = {
  SHOWCASE_LIVE: 'SHOWCASE_LIVE',
  SHOWCASE_MOVIE: 'SHOWCASE_MOVIE',
  SHOWCASE_SERIES: 'SHOWCASE_SERIES',
  SHOWCASE_SERIES_EPISODE: 'SHOWCASE_SERIES_EPISODE',
  SHOWCASE_SPECIAL: 'SHOWCASE_SPECIAL',
  SHOWCASE_UPCOMING: 'SHOWCASE_UPCOMING',
  SHOWCASE_CLIP: 'SHOWCASE_CLIP',
  SHOWCASE_PROMO: 'SHOWCASE_PROMO',
  SHOWCASE_CATEGORY: 'SHOWCASE_CATEGORY',
  SHOWCASE_COUNTDOWN: 'SHOWCASE_COUNTDOWN',
};

const BADGE_TYPES = {
  BADGE_AUDIO: 'AUDIO ONLY',
  BADGE_CONTINUE_LISTENING: 'CONTINUE LISTENING',
  BADGE_CONTINUE_WATCHING: 'CONTINUE WATCHING',
  BADGE_FEATURED: 'FEATURED',
  BADGE_LIVE: 'LIVE',
  BADGE_NEW: 'NEW',
  BADGE_UPCOMING: 'UPCOMING',
};

export { BUTTON_TYPES, SHOWCASE_TYPES, BADGE_TYPES };
